import { get, post } from '@/utils/apiBase.js';

// 获取宣传链接设置状态
const getPublicityLinkStatus = option => {
  return get('/apis/project/cp_admin/get_publicity_link_status', option)
}
// 获取宣传链接
const getProPublicityLink = option => {
    return get('/apis/project/cp_admin/pro_publicity_link', option)
}
// 创建kol推广连接
const createKolPublicityLink = option => {
  return post('/apis/project/cp_admin/create_kol_publicity_link', option)
}
// 获取达人推广列表
const getPublicityKolList = option => {
  return get('/apis/project/cp_admin/publicity_kol_list', option)
}
// 获取达人/KOL 推广详情
const getPublicityKolDetail = option => {
  return get('/apis/project/cp_admin/publicity_kol_detail', option)
}
// 判断当前达人/kol是否存在当前的推广场景类型
const checkKolPublicityExists = option => {
  return get('/apis/project/cp_admin/check_kol_publicity_exists', option)
}

export default {
    getPublicityLinkStatus,
    getProPublicityLink,
    createKolPublicityLink,
    getPublicityKolList,
    getPublicityKolDetail,
    checkKolPublicityExists
};
